import { API_URL, ACCOUNTS_PREFIX } from "@cti-workspace/helpers";
import { postApi } from "./api";

async function setPassword(password, tokenValue) {
	const url = `/${ACCOUNTS_PREFIX}/setPassword/`;
	return postApi(url, { password, tokenValue }, {}, false, API_URL, { authorization: `Bearer ${tokenValue}` });
}

export default setPassword;
